import { Entity } from '@core/data/dto/entity';
import { CourierVehicleType } from '../courier/courier-vehicle-type';
import { DtoExport, DtoImport } from '@core/utils/dto';
import { DeliveryOrderQuoteDriverSchema } from './delivery-order-quote-driver.schema';
import { DTO_DEFAULT, DtoType } from '@core/data/dto/dto-types';
import { Dto } from '@core/data/dto/dto';

export class DeliveryOrderQuoteDriver implements Entity {
    public id: string;
    public active: boolean;
    public name: string;
    public vehicleType: CourierVehicleType;
    public vehicleIdentifier: string;
    public avatarUrl: string;
    public phone: string;
    public orderCount: number;

    @DtoImport(DeliveryOrderQuoteDriverSchema)
    static import(dto: Dto): any {}

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: DeliveryOrderQuoteDriverSchema,
        },
    ])
    export(type?: DtoType): any {}
}
